// extracted by mini-css-extract-plugin
module.exports = {"blur":"WidgetBlur-blur-1062"};